import MsoolLogo from "@assets/svg/MsoolLogo.svg?react";
import React, { FC } from "react";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
`;

const BouncingLogo = styled(MsoolLogo)`
  animation: ${bounce} 2s infinite;
`;

interface LoaderProps {
  style?: React.CSSProperties;
  Text: string;
}

const MsoolLoader: FC<LoaderProps> = ({ style, Text }) => {
  return (
    <div
      style={style}
      className="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <div className="flex flex-col items-center justify-center">
        <BouncingLogo fontSize="150px" />
        <div className="text-2xl mt-6">{Text}</div>
      </div>
    </div>
  );
};

export default MsoolLoader;
